import { Box, Text } from '@hopskipdrive/react-components';
import { colorPalette, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Container = styled(Box)`
  &.MuiBox-root {
    display: flex;
    margin-top: 12px;
    padding: 24px;
    align-items: flex-start;
    flex-wrap: wrap;
    background: ${colorPalette.navy95};
    box-shadow: 0px 4px 10px 0px rgba(29, 75, 122, 0.1);
    border-radius: 5px;

    button {
      margin-left: auto;
    }

    ${variables.mediaQuery.lessThan('desktop')`   
       justify-content: center;
    `}
  }
`;

export const RiderContainer = styled(Box)`
  &.MuiBox-root {
    display: flex;
    margin-left: 2rem;

    @media (max-width: 1280px) {
      flex-direction: column;
    }

    @media (max-width: 819px) {
      flex-basis: 100%;
      margin-left: 0;
      margin-top: 1rem;
    }
  }
`;

export const RiderInfo = styled.div`
  display: flex;
  flex-direction: column;

  .MuiBox-root {
    display: flex;
    margin-bottom: 12px;

    a {
      font-weight: 500;
    }
  }
`;

export const Age = styled(Text)`
  font-size: 1.5rem;
`;

export const ContentLabelContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RiderName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
